import { render, staticRenderFns } from "./WarehouseTabPurchase.vue?vue&type=template&id=54317adf&scoped=true"
import script from "./WarehouseTabPurchase.vue?vue&type=script&lang=js"
export * from "./WarehouseTabPurchase.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabPurchase.vue?vue&type=style&index=0&id=54317adf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54317adf",
  null
  
)

export default component.exports